import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserRolePermissionResponse } from '../models/user-roles-permissions';
import { ApiResponse } from '../models/api-response';
import { HttpClient } from '@angular/common/http';
import { API_ENDPOINTS, buildEndpoint } from '../api-endpoint';
import { API_ENDPOINTS as API_ENDPOINTS_V2, buildEndpoint as buildEndpointV2 } from '../api-endpoints-v2';
import { RuntimeConfigService } from '../config/runtime-config.service';
import { VersionToggleService } from './version-toggle.service';

export interface User {
  name: string;
  initials: string;
  icon: string;
  disabled: boolean;
  role: string;
}

@Injectable({ providedIn: 'root' })
export class UserService {
  private baseApiUrl: string;
  private apiVersion: string;
  private baseApiV2Url: string;
  private apiVersionV2: string;

  constructor(
    private runtimeConfigService: RuntimeConfigService,
    private versionToggleService: VersionToggleService,
    private http: HttpClient
  ) {
    this.baseApiUrl = this.runtimeConfigService.apiUrl;
    this.apiVersion = this.runtimeConfigService.apiVersion;
    this.baseApiV2Url = this.runtimeConfigService.apiUrl;
    this.apiVersionV2 = this.runtimeConfigService.apiVersion;
  }

  getApiUrl(apiEndpoint: string): string {
    return buildEndpoint(this.baseApiUrl, this.apiVersion, 'reportservice', apiEndpoint);
  }

  private getPermissionsApiUrl(email: string): string {
    const endpoint = this.versionToggleService.isV2
      ? buildEndpointV2(
          this.baseApiV2Url,
          this.apiVersionV2,
          'reportservice',
          API_ENDPOINTS_V2.REPORT_SERVICE.PERMISSIONS.UserPermissions
        )
      : this.getApiUrl(API_ENDPOINTS.REPORT_SERVICE.PERMISSIONS.UserPermissions);

     return endpoint.includes('{email}')
       ? endpoint.replace('{email}', encodeURIComponent(email))
       : endpoint;
  }

  getUserPermissions(email: string): Observable<ApiResponse<UserRolePermissionResponse>> {
    const url = this.getPermissionsApiUrl(email);
    return this.http.get<ApiResponse<UserRolePermissionResponse>>(url);
  }
}
